import * as Sentry from '@sentry/react'

const setupSentry = () => {
  const { VITE_SENTRY_TRACES_SAMPLE_RATE, VITE_SENTRY_ENV } = import.meta.env
  const tracesSampleRate: string = VITE_SENTRY_TRACES_SAMPLE_RATE ?? '0.0'
  const tracesSampleRateAsNumber = parseFloat(tracesSampleRate)
  Sentry.init({
    dsn: 'https://ba8b865fe1cc11ee4528bc824591538d@o4509309700276224.ingest.de.sentry.io/4509309745365072',
    environment: VITE_SENTRY_ENV,
    tracesSampleRate: tracesSampleRateAsNumber
  })
}

export default setupSentry
